import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MangeVillageComponent } from './mange-village/mange-village.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VillageDetailsComponent } from './village-details/village-details.component';
import { AddVillageComponent } from './add-village/add-village.component';



@NgModule({
  declarations: [
    MangeVillageComponent,
    VillageDetailsComponent,
    AddVillageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class VillagesModule { }
